<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="notifications">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/3 flex items-center">
                  <h6 class="mr-2">ข้อมูลการส่ง Notification</h6>
                  <vx-tooltip text="สัญญาดังกล่าวเคยใช้งานผ่าน WEL Application แล้ว">
                    <vs-button color="success" type="filled" icon-pack="feather" icon="icon-smartphone" size="small" class="ml-1" v-if="isSignInStudentApp"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="สัญญาดังกล่าวยังไม่เคยใช้งานผ่าน WEL Application">
                    <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-smartphone" size="small" class="ml-1" v-if="!isSignInStudentApp"></vs-button>
                  </vx-tooltip>
                </div>

                <div class="vx-col w-2/3 flex justify-end m-0 p-0">
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"  @click="onPressedActiveAddNotification()">เพิ่มข้อมูล</vs-button>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th >#</vs-th>
              <vs-th >วันที่</vs-th>
              <vs-th >ประเภท</vs-th>
              <vs-th >หัวข้อ</vs-th>
              <vs-th class="col-actions">อ่านแล้ว</vs-th>
              <vs-th class="col-createdBy">ผู้บันทึก</vs-th>
              <vs-th class="col-approved">สถานะ</vs-th>
              <vs-th class="col-actions"></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td>{{ data.length - index }}</vs-td>
                <vs-td>{{ row.dateLocalTh }}</vs-td>
                <vs-td>{{ row.typeName }}</vs-td>
                <vs-td>{{ row.title }} <a class="cursor-pointer" @click="onPressedActiveInfoModal(row.description)"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" /></a></vs-td>
                <vs-td>
                  <vs-chip :color="row.isRead ? 'success' : 'danger'">
                    {{ row.isRead ? 'ใช่' : 'ไม่ใช่' }}
                  </vs-chip>
                </vs-td>
                <vs-td>{{ row.createdByFullName }}<br>{{ row.createdAtDateTimeLocalTh }}</vs-td>

                <vs-td>
                  <vs-chip  v-if="row.approvedStatus === IApprovedStatus.draft" color="warning">รอยืนยัน</vs-chip>
                  <vs-chip  v-if="row.approvedStatus === IApprovedStatus.approved" color="success">ยืนยันแล้ว</vs-chip>
                  <vs-chip  v-if="row.approvedStatus === IApprovedStatus.cancel" color="danger">ยกเลิก</vs-chip>
                </vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                    <vx-tooltip text="ยืนยันข้อมูล Notification">
                      <vs-button  class="mr-1" color="success" type="filled" icon-pack="feather" icon="icon-check" @click="onPressedApprovedNotification(row.id)" v-if="row.approvedStatus === IApprovedStatus.draft"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="แก้ไขข้อมูล Notification">
                      <vs-button  class="mr-1" color="warning" type="filled" icon-pack="feather" icon="icon-edit" @click="onPressedActiveUpdateNotification(row)" v-if="row.approvedStatus === IApprovedStatus.draft"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="ยกเลิกข้อมูล Notification">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-x-circle" @click="onPressedCanceledNotification(row.id)" v-if="row.approvedStatus === IApprovedStatus.approved"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip text="ลบข้อมูล Notification">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="onPressedDelNotification(row.id)" v-if="row.approvedStatus === IApprovedStatus.draft"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>

    <vs-popup
      :active.sync="infoModal.active"
      title="รายละเอียด"
      class="custom-popup"
    >
      <div class="mb-5">
        <p v-html="infoModal.text"></p>
      </div>
    </vs-popup>

    <vs-popup
      :active.sync="notificationModal.active"
      :title="notificationModal.title"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit">
            <div class="vx-row">
              <div class="vx-col w-full">
                <validation-provider :name="$t('sections.master.dataForm.notiTempName')" rules="" v-slot="{ errors }">
                  <label class="vs-input--label">{{ $t("sections.master.dataForm.notiTempName") }}</label>
                  <v-select v-model="notificationModal.notificationTemplate" :clearable="true" :options="notificationTemplateOptions" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-1/2">
                <ValidationProvider name="วันที่" rules="required" v-slot="{ errors }" >
                  <label class="text-sm">วันที่*</label>
                  <flat-pickr :config="configDateNotification" class="w-full" v-model="notificationModal.date"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <ValidationProvider name="หัวข้อ" rules="required" v-slot="{ errors }" >
                  <label class="text-sm">หัวข้อ*</label>
                  <vs-input type="text" class="w-full" v-model="notificationModal.title"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <label class="text-sm">รายละเอียด*</label>
                <vs-textarea  v-model="notificationModal.description" rows="5"/>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <p><b>*ดำเนินการส่ง Notification แบบกำหนดเอง ไปยัง <label class="text-danger">"WEL Application"</label> โดยไม่จำกัดว่าผู้ใช้งานเคยใช้งาน Application หรือไม่ โดย Notification จะถูกส่งไปยังผู้งานเมื่อทำการ Approved เท่านั้น</b></p>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptNotificationModel">บันทึก</vs-button>
        <vs-button color="danger" @click="notificationModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Divider from "@/views/components/vuesax/divider/Divider.vue";
import {createNamespacedHelpers, mapGetters} from "vuex";
import vSelect from "vue-select";
import moment from "moment";
import { Thai } from 'flatpickr/dist/l10n/th'
import 'flatpickr/dist/themes/dark.css';
import flatPickr from "vue-flatpickr-component";
import {IApprovedStatus, INotificationType} from "@/constants/interface";
const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');
const { mapActions: mapMasterActions } = createNamespacedHelpers('Master')

export default {
  name: 'NotificationTab',
  components: {
    vSelect,
    Divider,
    flatPickr
  },
  data() {
    return {
      infoModal: {
        active: false,
        text: ""
      },
      clearTransactionsPopup: {
        active: false,
        date: moment().format('DD-MM-YYYY'),
      },
      notificationModal: {
        active: false,
        type: 'add',
        notificationTemplate: '',
        id: null,
        date: moment().format('DD-MM-YYYY'),
        title: 'เพิ่มข้อมูล Notification',
        description: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      notificationTemplateOptions :'Master/notificationTemplateOptions',
    }),
    ...mapAccountingFields(['contractDetail','contractDetailNotifications']),
    IApprovedStatus() {
      return IApprovedStatus
    },
    isSignInStudentApp() {
      if(!this.contractDetail) return false
      return this.contractDetail.isSignInStudentApp
    },
    configDateNotification(){
      let minDate = null
      let maxDate = null

      return {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      }
    },
    notifications() {
      if (!this.contractDetailNotifications) return null;
      return [...this.contractDetailNotifications]
        .sort(({ date: aDate, createdAt: aCreatedAt }, { date: bDate, createdAt: bCreatedAt }) => {
          const dateDiff = new Date(bDate) - new Date(aDate);
          if (dateDiff !== 0) {
            return dateDiff;
          }
          return new Date(bCreatedAt) - new Date(aCreatedAt);
        })
        .map((notification) => {
          const {
            id,
            date,
            typeName,
            title,
            description,
            isRead,
            readAt,
            createdAtDateTimeLocalTh,
            createdByFullName,
            dateLocalTh,
            approvedStatus,
          } = notification;

          return {
            id,
            date,
            typeName,
            title,
            description,
            isRead,
            readAt,
            createdAtDateTimeLocalTh,
            createdByFullName,
            dateLocalTh,
            approvedStatus,
          }
        })
    },
  },
  methods: {
    ...mapAccountingActions(['getContractDetail', 'approvedContractDetailNotification', 'createContractDetailNotification', 'approvedContractDetailNotification', 'cancelContractDetailNotification', 'updateContractDetailNotification', 'deleteContractDetailNotification']),
    ...mapMasterActions(['getNotificationTemplateOptions']),
    async onPressedActiveAddNotification() {
      const vm = this
      vm.notificationModal.notificationTemplate = null
      vm.notificationModal.type = 'add'
      vm.notificationModal.id = null
      vm.notificationModal.date = moment().format('DD-MM-YYYY');
      vm.notificationModal.title = 'เพิ่มข้อมูล Notification';
      vm.notificationModal.description = "";
      vm.notificationModal.active = true
    },
    async onPressedApprovedNotification(id) {
      const vm = this
      const contractId  = vm.$route.params.id;
      const { approvedContractDetailNotification, getContractDetail } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'ยืนยันข้อมูล',
        text: 'คุณต้องการยืนยันข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await approvedContractDetailNotification({
            id,
            vm
          });
          await getContractDetail({
            id: contractId
          })
        }
      })
    },
    async onPressedCanceledNotification(id) {
      const vm = this
      const contractId  = vm.$route.params.id;
      const { cancelContractDetailNotification, getContractDetail } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการยกเลิกข้อมูล',
        text: 'คุณต้องการยกเลิกข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await cancelContractDetailNotification({
            id,
            vm
          });
          await getContractDetail({
            id: contractId
          })
        }
      })
    },
    async onPressedActiveUpdateNotification(row) {
      const vm = this;
      vm.notificationModal.notificationTemplate = null
      // delay 1 sec
      setTimeout(() => {
        vm.notificationModal.type = 'update'
        vm.notificationModal.id = row.id;
        vm.notificationModal.date = moment(row.date).format('DD-MM-YYYY');
        vm.notificationModal.title = row.title;
        vm.notificationModal.description = row.description;
        vm.notificationModal.active = true
      }, 500);

    },
    async onPressedAcceptNotificationModel() {
      const vm = this
      const contractId  = vm.$route.params.id;
      const {createContractDetailNotification, updateContractDetailNotification, getContractDetail } = vm;
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        const date = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.notificationModal.date.trim())
        if(vm.notificationModal.type === 'add') {
          await createContractDetailNotification({
            contractId,
            form: {
              date,
              type: INotificationType.custom,
              title: vm.notificationModal.title,
              description: vm.notificationModal.description,
            }
          })
        }else if(vm.notificationModal.type === 'update') {
          await updateContractDetailNotification({
            id: vm.notificationModal.id,
            form: {
              date,
              type: INotificationType.custom,
              title: vm.notificationModal.title,
              description: vm.notificationModal.description,
            }
          })
        }
        await getContractDetail({
          id: contractId
        })
        vm.notificationModal.active = false;
      })
    },
    async onPressedDelNotification(id) {
      const vm = this
      const { deleteContractDetailNotification } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่?',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteContractDetailNotification({
            id,
            vm
          })
        }
      })
    },
    async onPressedActiveInfoModal(description) {
      this.infoModal.text = description
      this.infoModal.active = true
    },
  },
  async created () {
    const vm = this
    const { getNotificationTemplateOptions } = vm;
    await getNotificationTemplateOptions();
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
    'notificationModal.notificationTemplate': function(newVal) {
      if(newVal){
        this.notificationModal.title = newVal.title
        this.notificationModal.description = newVal.description
      }else{
        this.notificationModal.title = ""
        this.notificationModal.description = ""
      }
    }
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.col-createdBy {
  width: 200px;
}

.col-approved {
  width: 130px;
}

.col-actions {
  width: 100px;
}

.col-sm {
  width: 80px;
}

.custom-popup .vs-popup {
  width: 600px;
}
.popup-content {
  padding: 10px;
}
.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}
.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
